import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

const ColListWrapper = ({
  as = 'ul',
  grouped = false,
  className,
  children,
  scrollable = false,
  maxHeight,
  nested = false,
}) => {
  const Wrapper = as;

  return (
    <Wrapper
      style={{ '--col-list-wrapper-max-height': maxHeight }}
      className={cn(styles.root, className, {
        [styles.groupedList]: grouped,
        [styles.scrollable]: scrollable,
        [styles.nested]: nested,
      })}
    >
      {children}
    </Wrapper>
  );
};

export default ColListWrapper;
